import { useAxiosConfig } from '@shared/api/AxiosConfigProvider';
import { refreshQueries } from '@shared/api/hooks/refresh-queries';
import { getAppIngredientPickerListQueryKey } from '@shared/api/lib/app/app';
import {
  getIngredientsListQueryKey,
  useIngredientsList,
  useIngredientsRetrieve,
  useIngredientsUpdate,
} from '@shared/api/lib/ingredients/ingredients';
import {
  IngredientDetail,
  IngredientsListParams,
  PaginatedIngredientListList,
} from '@shared/api/types';
import { useQueryClient } from '@tanstack/react-query';

export const useGetIngredients = (params: IngredientsListParams) => {
  return useIngredientsList<PaginatedIngredientListList>(params, {
    request: useAxiosConfig(),
    query: {
      keepPreviousData: true,
    },
  });
};

export const useGetIngredient = (ingredientUuid: string) => {
  return useIngredientsRetrieve<IngredientDetail>(ingredientUuid, {
    request: useAxiosConfig(),
  });
};

export const usePatchIngredient = () => {
  const queryClient = useQueryClient();

  return useIngredientsUpdate({
    request: useAxiosConfig(),
    mutation: {
      onSuccess: () =>
        Promise.all([
          refreshQueries(queryClient, getIngredientsListQueryKey()),
          refreshQueries(queryClient, getAppIngredientPickerListQueryKey()),
        ]),
    },
  });
};
